import { Pagination } from "../Pagination.tsx";

export function TablePagination({
  currentPage,
  totalPages,
  onChangePage,
}: {
  currentPage: number;
  totalPages: number;
  onChangePage: (page: number) => void;
}) {
  if (totalPages <= 1) return null;
  return (
    <div className={"flex flex-col items-center gap-2"}>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onChangePage={onChangePage}
      />
      <span className={"text-sm text-slate-500"}>
        Page {currentPage + 1} of {totalPages}
      </span>
    </div>
  );
}
